<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      :overlay="true"
      max-width="400"
      transition="dialog-transition"
    >
      <!-- <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" class="info" color="white"
          >Category
          <v-icon right>fas fa-sitemap</v-icon>
        </v-btn>
      </template> -->
      <v-card class="" max-width="400">
        <v-card-title>
          <v-toolbar class="teal darken-4 white--text">
            <v-toolbar-title>Create New Unit Type</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="white" :disabled="clicked" @click="close" icon small>
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-form ref="UnitTypeForm" class="mt-2">
            <v-text-field
              outlined
              v-model.trim="UnitType"
              :rules="[rules.required]"
              label="Unit Type"
              id="UnitType"
            ></v-text-field>

            <p class="font-weight-black mt-3 text-center" v-html="msgError"></p>
            <v-btn
              block
              @click="OnAddType"
              :loading="clicked"
              class="elevation-6"
              rounded
              color="red darken-3"
              dark
              width="150"
              >Create</v-btn
            >
          </v-form>
          <v-card-actions> </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  // AccCharts
  props: {
    OpenUnitType: { type: Boolean, required: true },
    loadFunction: { type: Function, required: true },
  },

  data() {
    return {
      URL: "/AccCharts/UnitType",
      dialog: false,
      msgError: "",
      clicked: false,
      UnitType: "",
      rules: {
        required: v => {
          if (!v) return "Type Required.";
          else if (v.length > 3) return "Only 3 Character allowed";
          return true;
        },
      },
      //   dialog: false,
    };
  },
  watch: {
    OpenUnitType(v) {
      if (v) this.dialog = v;
    },
  },

  methods: {
    close() {
      this.dialog = false;
      this.$emit("UnitTypeClose", false);
      this.msgError = "";
    },
    OnAddType() {
      this.msgError = "";
      if (this.$refs.UnitTypeForm.validate()) {
        this.clicked = true;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: this.URL,
            data: {
              UnitType: this.UnitType.toUpperCase(),
              // category: this.Category,
              //   AccountName: this.CategName
            },
          })
          .then(() => {
            this.clicked = false;
            this.$refs.UnitTypeForm.reset();
            this.loadFunction();
            this.close();
            // console.log(result);
            // this.AllSuppliers = result.data;
          })
          .catch(err => {
            this.clicked = false;
            this.msgError = err.response.data;
            // console.log(err);
          });
      }
    },
  },
};
</script>
<style scoped>
span {
  /* border-bottom: solid double 2px black; */
  border-bottom: double black;
}
</style>
